const SEEN_KEY = "lafiesta:welcomed";

// First-visit welcome shown over the party once you enter: what this is, that
// your vote stays secret, an animated joystick demo (move + turn), and where to
// find Help. Stored in localStorage so it only appears the first time.
export function showWelcomeOnce(onClose?: () => void): void {
  let seen = false;
  try {
    seen = localStorage.getItem(SEEN_KEY) === "1";
  } catch { /* private mode — just show it */ }
  if (seen) return;
  try {
    localStorage.setItem(SEEN_KEY, "1");
  } catch { /* ignore */ }
  showWelcome(onClose);
}

export function showWelcome(onClose?: () => void): void {
  const overlay = document.createElement("div");
  overlay.className =
    "fixed inset-0 z-40 flex items-center justify-center bg-black/40 p-4";

  const card = document.createElement("div");
  card.className =
    "flex max-h-[90vh] w-full max-w-md flex-col gap-3 overflow-auto rounded-2xl border-2 border-black bg-white p-6 text-center shadow-2xl";
  card.innerHTML = `
    <h1 class="text-2xl font-bold">¡Hola! 🎉</h1>
    <p class="text-sm leading-relaxed">
      Esta es <b>la fiesta de la democracia</b>. Acá están las personas y los
      candidatos y candidatas, todos invitados.
    </p>
    <p class="text-sm leading-relaxed">
      Puedes parchar ahí sin que nadie sepa por quién vas a votar. 🤫
    </p>
  `;

  card.appendChild(buildJoyDemo());

  const move = document.createElement("p");
  move.className = "text-sm leading-relaxed";
  move.innerHTML =
    "Muévete con el <b>joystick</b> — o, en el computador, haciendo " +
    "<b>scroll</b>: adelante, atrás y girar a los lados (las flechas ← → " +
    "también giran).";
  card.appendChild(move);

  const ideas = document.createElement("p");
  ideas.className = "text-sm leading-relaxed";
  ideas.innerHTML =
    "Al fondo están las ideas, por temas, de tu candidato/a y de otra gente " +
    "experta. <b>Acércate</b> y haz clic en el botón que aparece abajo. 📋";
  card.appendChild(ideas);

  const help = document.createElement("p");
  help.className = "text-xs opacity-60";
  help.innerHTML =
    "¿Dudas? Toca el botón <b>❓</b> (abajo a la derecha) cuando quieras.";
  card.appendChild(help);

  const credit = document.createElement("p");
  credit.className = "text-xs opacity-60";
  credit.innerHTML =
    "Un proyecto de <b>Economía para la Pipol</b> y <b>Datasketch</b>.";
  card.appendChild(credit);

  const go = document.createElement("button");
  go.className =
    "mt-1 self-center rounded-xl border-2 border-black px-6 py-2 text-lg font-bold";
  go.textContent = "¡A parchar! →";
  go.addEventListener("click", () => {
    overlay.remove();
    onClose?.();
  });
  card.appendChild(go);

  const logos = document.createElement("div");
  logos.className = "mt-1 flex items-center justify-center gap-4 opacity-70";
  logos.innerHTML = `
    <img src="/assets/sponsors/economia-para-la-pipol.png"
      alt="Economía para la Pipol" class="h-6 w-auto" />
    <img src="/assets/sponsors/datasketch.png"
      alt="Datasketch" class="h-6 w-auto" />
  `;
  card.appendChild(logos);

  overlay.appendChild(card);
  document.body.appendChild(overlay);
}

// A small joystick whose thumb loops through the four moves, with labels.
function buildJoyDemo(): HTMLElement {
  const wrap = document.createElement("div");
  wrap.className = "relative mx-auto my-1 h-40 w-40 select-none";

  const label = (text: string, pos: string) => {
    const d = document.createElement("div");
    d.className = `absolute text-xs font-bold ${pos}`;
    d.textContent = text;
    wrap.appendChild(d);
  };
  label("↑ adelante", "left-1/2 top-0 -translate-x-1/2");
  label("↓ atrás", "bottom-0 left-1/2 -translate-x-1/2");
  label("← girar", "left-0 top-1/2 -translate-y-1/2");
  label("girar →", "right-0 top-1/2 -translate-y-1/2");

  const base = document.createElement("div");
  base.className =
    "absolute left-1/2 top-1/2 h-24 w-24 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-black/40 bg-black/5";
  const thumb = document.createElement("div");
  thumb.className =
    "animate-joy absolute left-1/2 top-1/2 h-10 w-10 rounded-full border-2 border-black bg-black/20";
  base.appendChild(thumb);
  wrap.appendChild(base);
  return wrap;
}
